module.exports = __webpack_public_path__ + "static/media/video_placeholder.bf53f70f.jpg";